import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { baseUrl, DOWNLOAD_FILE } from "../../api/endpoints.js";
const Image = ({ className, id, size, width, height, defualtWidth }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };
  const baseUrls = `${baseUrl}/${DOWNLOAD_FILE}/`;
  return (
    <div className={className || ""}>
      {id && !imageError ? (
        <LazyLoadImage
          src={
            baseUrls +
            id +
            `${
              String(id).substr(String(id).length - 1) === "?" ? "&" : "?"
            }size=${size ? size : "small"}`
          }
          width={width ? width : "auto"}
          height={height ? height : "auto"}
          effect="opacity"
          data-srcset={`
      ${baseUrls + id + "?size=thumbnail"} 150w,
      ${baseUrls + id + "?size=small"} 300w,
      ${baseUrls + id + "?size=medium"} 768w,
      ${baseUrls + id + "?size=large"} 1024w,
      ${baseUrls + id + ""} 2000w,
      `}
          placeholderSrc={baseUrls + id + "?size=favicon"}
          alt="Image Alt"
          delayTime={1}
          onError={handleImageError}
          className={className || ""}
        />
      ) : (
        <img
          src="/images/icons/no-image.svg"
          alt=""
          width={defualtWidth ? defualtWidth : width ? width : "auto"}
          height={height ? height : "auto"}
          className={className || ""}
        />
      )}
    </div>
  );
};

export default Image;
